import React from 'react';
import { View, Text } from 'react-native';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export interface DailyRevenueLineChartProps {
  data: Array<{ date: string; revenue: number }>;
  width?: number | string;
  height?: number;
  lineColor?: string;
}

const DailyRevenueLineChart: React.FC<DailyRevenueLineChartProps> = ({ 
  data = [], 
  width = '100%', 
  height = 120,
  lineColor = '#FFB84D'
}) => {
  const chartData = React.useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.map((d) => ({
      date: typeof d.date === 'string' ? d.date.slice(5) : '',
      revenue: Number.isFinite(Number(d.revenue)) ? Number(d.revenue) : 0,
    }));
  }, [data]);

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <View style={{ 
          backgroundColor: '#292D33', 
          padding: 8, 
          borderRadius: 6,
          borderWidth: 1,
          borderColor: '#636363'
        }}>
          <Text style={{ color: '#FFFFFF', fontSize: 12, fontWeight: '600' }}>
            ${Number(payload[0].value).toFixed(2)}
          </Text>
        </View>
      );
    }
    return null;
  };

  return (
    <View style={{ width, height: height + 20 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" />
          <XAxis 
            dataKey="date" 
            stroke="#8D8E90" 
            style={{ fontSize: 10 }}
            tickLine={false}
          />
          <YAxis 
            stroke="#8D8E90" 
            style={{ fontSize: 10 }}
            tickFormatter={(value) => `$${value}`}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line 
            type="monotone" 
            dataKey="revenue" 
            stroke={lineColor} 
            strokeWidth={2.5}
            dot={{ fill: lineColor, r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </View>
  );
};

export default DailyRevenueLineChart;

